import { ContentManagerSummaryDTO } from '@activia/cm-api';
import { CountCardValueSize } from '@activia/dataviz';
import { FileSizePipe } from '@activia/ngx-components';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { TranslocoService } from '@ngneat/transloco';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { ContentOverviewService } from './content-overview.service';

@Component({
  selector: 'amp-content-overview',
  styleUrls: ['./content-overview.component.scss'],
  templateUrl: './content-overview.component.html',
})
export class ContentOverviewComponent implements OnInit, OnDestroy {
  dataSource = new Map<string, { value: number; uom: string; footerText: string }>();
  CountCardValueSize = CountCardValueSize;

  overview$: Observable<ContentManagerSummaryDTO>;

  private overview: ContentManagerSummaryDTO;

  constructor(private overviewService: ContentOverviewService, private fileSizePipe: FileSizePipe, private translate: TranslocoService) {
    this.overview$ = this.overviewService.getContentOverview().pipe(
      tap((overview) => {
        this.overview = overview;
        this.updateDataSource(overview);
      })
    );
  }

  ngOnInit(): void {
    this.overviewService.start();
  }

  ngOnDestroy(): void {
    // unsubscribe all subscriptions
    this.overviewService.stop();
  }

  private updateDataSource(overview) {
    for (const overviewKey of Object.keys(overview)) {
      switch (overviewKey) {
        case 'videoCount':
          this.setOverview(overviewKey, false, 'dashboardScope.dashboard.content.videos');
          break;
        case 'videoDiskSpace':
          this.setOverview(overviewKey, true, 'dashboardScope.dashboard.content.videos-used-space');
          break;
        case 'imageCount':
          this.setOverview(overviewKey, false, 'dashboardScope.dashboard.content.images');
          break;
        case 'imageDiskSpace':
          this.setOverview(overviewKey, true, 'dashboardScope.dashboard.content.images-used-space');
          break;
        case 'htmlArchiveCount':
          this.setOverview(overviewKey, false, 'dashboardScope.dashboard.content.apps');
          break;
        case 'htmlArchiveDiskSpace':
          this.setOverview(overviewKey, true, 'dashboardScope.dashboard.content.apps-used-space');
          break;
        case 'playlistCount':
          this.setOverview(overviewKey, false, 'dashboardScope.dashboard.content.playlists');
          break;
        case 'freeDiskSpace':
          this.setOverview(overviewKey, true, 'dashboardScope.dashboard.content.free-space');
          break;
        case 'usedDiskSpace':
          this.setOverview(overviewKey, true, 'dashboardScope.dashboard.content.used-space');
          break;
      }
    }
  }

  private setOverview(overviewKey, isUom, footerText) {
    this.dataSource.set(overviewKey, {
      value: isUom ? this.getDataFormattedValue(this.overview[overviewKey]) : this.overview[overviewKey],
      footerText: this.translate.translate(footerText),
      uom: isUom ? `${this.getDataUnit(this.overview[overviewKey])}` : null,
    });
  }

  private getDataUnit(rawValue: number): string {
    return this.fileSizePipe.format(rawValue).unit;
  }

  private getDataFormattedValue(rawValue: number): number {
    return this.fileSizePipe.format(rawValue).value;
  }
}
